// @ts-check
import React, { useEffect, useState } from "react"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import { formatHours } from "../../../../utils/time.utils"
import InputTextForm from "../../../../components/molecules/InputTextForm.molecule"
import useToast from "../../../../hooks/useToast.hook"
import useSessionContext from "../../../../hooks/contextConsumers/useSessionContext.hook"
import FormContainer from "../../../../components/layouts/containers/FormContainer.container"
import FieldContainer from "../../../../components/layouts/containers/FieldContainer.container"
import useTimeRegisterContext from "../../hooks/useTimeRegisterContext.hook"
import TimeTemplate from "../timeSummary/components/TimeTemplate"

const MIN_HOURS = 0
const MAX_HOURS = 0

const VacationDayDialog = ({
  visible,
  setVisible,
  todaySisuTime,
  todayBilledTime,
  onSubmit,
}) => {
  const {
    selectedDate,
    showedMissingDayDialog,
    setShowedMissingDayDialog,
    setEditingMissingDay,
  } = useTimeRegisterContext()
  const noBilledTime = Math.abs(todaySisuTime - todayBilledTime) || 0
  const [comment, setComment] = useState("")
  const [error, setError] = useState(
    /** @type {string | undefined} */ (undefined)
  )
  const { setSuccessMessage, setErrorMessage } = useToast()
  const { user } = useSessionContext()

  useEffect(() => {
    setComment("")
    setError(undefined)
  }, [selectedDate])

  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      header={
        <div className="flex gap-3 align-items-center">
          <i className="pi pi-check text-4xl" style={{ color: "#00B4FF" }} />
          <span className="text-3xl font-semibold font-cairo">
            Finalizar día
          </span>
        </div>
      }
      service={() => {
        if (!comment && !user?.isAdmin()) {
          setError("Por favor, escribe un comentario")
          return
        }
        setVisible(false)
        setVisible(false)
        onSubmit(comment)
          .then(() => {
            setSuccessMessage({
              title: "Finalizaste tu día",
              message: "Tus tareas de hoy se han guardado correctamente.",
            })
            setError(undefined)
            if (showedMissingDayDialog) {
              setShowedMissingDayDialog(false)
              setEditingMissingDay(false)
            }
          })
          .catch((error) => {
            setError(error)
            setErrorMessage({
              title: "Error",
              message:
                "No se pudo guardar el día, intenta de nuevo o contacta al administrador.",
            })
          })
      }}
    >
      <div className="finish-day-modal flex flex-column gap-3 pb-2">
        <span className="font-bold">Resumen del día</span>
        <div className="grid w-full px-2">
          <div className="col-5 worker-hours flex flex-column gap-3">
            <TimeTemplate
              icon="pi pi-clock total-time-this-week-icon"
              label="Horas trabajadas"
              time={todaySisuTime}
              min={MIN_HOURS}
              max={MAX_HOURS}
            />
          </div>
          <div className="col-5 no-billed-hours flex flex-column gap-3">
            <span className="flex gap-2 align-items-center">
              <i className="pi pi-dollar" style={{ color: "#F3D079" }}></i>
              Horas no facturadas
            </span>
            <span className="text-2xl font-semibold">
              {formatHours(noBilledTime)}
            </span>
          </div>
        </div>
        ¡Oye! No deberías estar trabajando en tus días libres ¿Quieres contarnos
        por qué cambiaron tus planes?
        <FormContainer>
          <FieldContainer className="w-full m-0">
            <InputTextForm
              label="Comentario"
              placeholder="Escribe aquí tus comentarios"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              error={error ? [{ errorMessage: error }] : []}
              optional={user?.isAdmin()}
            />
          </FieldContainer>
        </FormContainer>
      </div>
    </ModalForm>
  )
}

export default VacationDayDialog
